// Login
export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST"
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS"
export const INTIALIZE_TOKEN = "INTIALIZE_TOKEN"
export const REMOVE_TOKEN = "REMOVE_TOKEN"
export const FETCH_FORGET_SUCCESS = "FETCH_FORGET_SUCCESS"
export const  FETCH_Lang_REQUEST=" FETCH_Lang_REQUEST"
export const FETCH_CONFIRM_ACCOUNT = "FETCH_CONFIRM_ACCOUNT"
export const ACCOUNT_NOT_VERIFIED = "ACCOUNT_NOT_VERIFIED"
export const FETCH_SIGNUP_SUCCESS = "FETCH_SIGNUP_SUCCESS"
export const RESET_SIGNUP_SUCCESS = "RESET_SIGNUP_SUCCESS"
export const FETCH_UPDATE_REQUEST = "FETCH_UPDATE_REQUEST"
export const CLOSE_MENU = "CLOSE_MENU"
export const CLOSE_MENU_MOBILE = "CLOSE_MENU_MOBILE"
export const  FETCH_CODE_SUCCESS="FETCH_CODE_SUCCESS"
export const FETCH_NEWPASS_SUCCESS="FETCH_NEWPASS_SUCCESS"
export const  FETCH_ACTIVE_STUDENT_SUCCESS=" FETCH_ACTIVE_STUDENT_SUCCESS"

// CHAT
export const FETCH_NEW_MESSAGE = "FETCH_NEW_MESSAGE"
export const FETCH_TOKEN = "FETCH_TOKEN"
export const UPDATE_NOTIFICATION_COUNT = "UPDATE_NOTIFICATION_COUNT"
export const DELETE_NEW_MESSAGE  = "DELETE_NEW_MESSAGE"
export const FETCH_USER_TYPING = "FETCH_USER_TYPING"
export const ACTIVATELEVEL="ACTIVATELEVEL"
export const CLEAR_MSG_COUNT="CLEAR_MSG_COUNT"
export const CLEAR_NOTIFICATION_COUNT="CLEAR_NOTIFICATION_COUNT"
// Assign Rules
export const FETCH_ASSIGN_SUCCESS = "FETCH_ASSIGN_SUCCESS"
export const UPDATE_MESSAGE_COUNT="UPDATE_MESSAGE_COUNT"
export const SET_USER_TYPE = "SET_USER_TYPE"
